import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ErrorBoundary } from 'bernie-view';

import { QuestionAnswersViewModel } from 'src/common/models/hotel/hotel-details-types';

import { FindAnswersCta } from 'components/infosite/find-answers/find-answers-cta';

export interface FindAnswersInputProps {
  questionAnswersViewModel?: QuestionAnswersViewModel;
  topPadding?: boolean;
  reviewsDialogInput?: boolean;
}

export class FindAnswersInput extends React.PureComponent<FindAnswersInputProps> {
  public render() {
    const { questionAnswersViewModel, topPadding, reviewsDialogInput } = this.props;

    if (!questionAnswersViewModel) {
      return null;
    }

    const enabledForConventionalLodging = questionAnswersViewModel && questionAnswersViewModel.enabledForConventionalLodging;
    const enabledForHomeAway = questionAnswersViewModel && questionAnswersViewModel.enabledForHomeAway;

    return (
      <React.Fragment>
        {enabledForConventionalLodging && (
          <AbacusExperiment name="PWA_HIS_QUESTIONS_ANSWERS_TOP_DESTINATIONS">
            <AbacusControl />
            <AbacusVariant bucket={1}>
              {(topPadding || reviewsDialogInput) && (
                <ErrorBoundary label="hotel.information.findAnswers_1">
                  <FindAnswersCta topPadding={true} reviewsDialogInput={reviewsDialogInput} />
                </ErrorBoundary>
              )}
            </AbacusVariant>
            <AbacusVariant bucket={2}>
              {(!topPadding || reviewsDialogInput) && (
                <ErrorBoundary label="hotel.information.findAnswers_2">
                  <FindAnswersCta reviewsDialogInput={reviewsDialogInput} />
                </ErrorBoundary>
              )}
            </AbacusVariant>
            <AbacusVariant bucket={3} />
          </AbacusExperiment>
        )}
        {enabledForHomeAway &&
          topPadding &&
          !enabledForConventionalLodging && (
            <ErrorBoundary label="hotel.information.findAnswers_vr">
              <FindAnswersCta topPadding={true} />
            </ErrorBoundary>
          )}
      </React.Fragment>
    );
  }
}
